<template>
	<div>
		<van-nav-bar
			title="个人中心"
			left-text="返回"
			left-arrow
			@click-left="onClickLeft"
		/>
		<van-cell center>
			<!-- 使用 title 插槽来自定义标题 -->
			<template #title>
				<img
					class="avanta"
					width="100"
					height="100"
					v-bind:src="userInfo.headImgUrl"
				/>
				<div class="name">{{ userInfo.nickName }}</div>
				<div class="name school">{{ userInfo.schoolName }}</div>
			</template>
		</van-cell>

		<van-cell-group title=" ">
			<van-cell icon="manager-o" is-link to="userRelation">
				<template #title>
					<b>书柜绑定</b>
				</template>
				<template #label>
					<div>书柜:{{ userInfo.schoolName }}</div>
					<div>所属:{{ userInfo.className }}</div>
					<div>姓名:{{ userInfo.studentName }}</div>
					<!-- <div>编号:{{ userInfo.studentCode }}</div> -->
				</template>
				<template #default style="width:100px;">
					<span
						v-if="
							userInfo.studentName == null ||
								userInfo.studentName == '' ||
								userInfo.studentName == undefined
						"
						>绑定
					</span>

					<span
						v-if="
							!(
								userInfo.studentName == null ||
								userInfo.studentName == '' ||
								userInfo.studentName == undefined
							)
						"
						>更换
					</span>
				</template>
			</van-cell>
		</van-cell-group>

		<van-cell-group title=" ">
			<van-cell icon="paid" v-if="userInfo.yaJin == 1" is-link>
				<template #title>
					<b>押金</b>
				</template>
				<template #label>
					<span>金额:{{ userInfo.hasDeposit }}元</span>
				</template>
				<template #default>
					<van-button
						type="primary"
						size="small"
						v-if="userInfo.hasDeposit < 50"
						@click="onClick_wxPay_yj"
						>充值</van-button
					>
					<van-button
						type="primary"
						size="small"
						v-if="userInfo.hasDeposit >= 50"
						@click="onClick_wxPay_refundYJ"
						>退还</van-button
					>
				</template>
			</van-cell>

			<van-cell icon="paid" v-if="userInfo.yaJin != 1">
				<template #title>
					<b>押金</b>
				</template>
				<template #label> </template>
				<template #default>
					<span>免押金</span>
				</template>
			</van-cell>

			<van-cell
				icon="paid"
				v-if="userInfo.chongZhi == 1"
				is-link
				clickable
				@click="onClick_DateCharge"
			>
				<template #title>
					<b>VIP有效期</b>
				</template>
				<template #label>
					<span>截止日期:{{ userInfo.vipEndDate }}</span>
				</template>
				<template #default>
					<span>充值</span>
				</template>
			</van-cell>

			<van-cell icon="paid" v-if="userInfo.chongZhi != 1">
				<template #title>
					<b>VIP有效期</b>
				</template>
				<template #label> </template>
				<template #default>
					<span>免充值</span>
				</template>
			</van-cell>

			<van-popup
				v-model="showCharge_Date"
				position="bottom"
				round
				:style="{ height: '80%' }"
			>
				<van-nav-bar
					title="VIP充值"
					left-text="取消"
					@click-left="showCharge_Date = false"
				/>
				<van-grid :column-num="2" :gutter="10" class="grid-margin">
					<van-grid-item
						v-for="v in cards_date"
						:key="v.id"
						@click="onGridItemClick_DateCharge(v.id)"
						v-bind:class="v.cls"
					>
						<template #default>
							<div>
								<h3>{{ v.name }}</h3>
							</div>
							<div>
								<span>{{ v.display }}元</span>
							</div>
						</template>
					</van-grid-item>
				</van-grid>
				<van-row>
					<van-col span="22" offset="1">
						<van-button
							type="primary"
							block
							class="btn-wxpay"
							:disabled="!selectedCard"
							@click="onClick_wxPay_date"
							>支付</van-button
						>
					</van-col>
				</van-row>
			</van-popup>

			<!-- <van-cell
				icon="paid"
				is-link
				v-if="userInfo.payType >= 2"
				clickable
				@click="onClick_TimeCharge"
			>
				<template #title>
					<b>剩余借阅次数</b>
				</template>
				<template #label>
					<span>剩余次数:{{ userInfo.leftTimes }}次</span>
				</template>
				<template #default>
					<span>充值</span>
				</template>
			</van-cell>
			<van-cell icon="paid" v-if="userInfo.payType < 2">
				<template #title>
					<b>剩余借阅次数</b>
				</template>
				<template #label> </template>
				<template #default>
					<span>免充值</span>
				</template>
			</van-cell> -->
			<van-popup
				v-model="showCharge_Time"
				position="bottom"
				round
				:style="{ height: '80%' }"
			>
				<van-nav-bar
					title="借阅次数充值"
					left-text="取消"
					@click-left="showCharge_Time = false"
				/>
				<van-grid :column-num="2" :gutter="10" class="grid-margin">
					<van-grid-item
						v-for="v in cards_time"
						:key="v.id"
						@click="onGridItemClick_TimeCharge(v.id)"
						v-bind:class="v.cls"
					>
						<template #default>
							<div>
								<h3>{{ v.name }}次</h3>
							</div>
							<div>
								<span>{{ v.display }}元</span>
							</div>
						</template>
					</van-grid-item>
				</van-grid>
				<van-row>
					<van-col span="22" offset="1">
						<van-button
							type="primary"
							block
							class="btn-wxpay"
							:disabled="!selectedCard"
							@click="onClick_wxPay_times"
							>支付</van-button
						>
					</van-col>
				</van-row>
			</van-popup>
		</van-cell-group>

		<van-cell-group title=" ">
			<van-cell title="优惠券" value="兑换" icon="discount" is-link />
			<van-cell title="阅读积分" v-bind:value="jifen" icon="gem-o" is-link />
		</van-cell-group>

		<van-cell-group title=" ">
			<van-cell title="订单" is-link icon="todo-list-o" />
			<van-cell title="收藏" is-link icon="star-o" to="wish" />
		</van-cell-group>
	</div>
</template>

<script>
import {
	Cell,
	CellGroup,
	NavBar,
	Image as VanImage,
	Popup,
	Grid,
	GridItem,
	Col,
	Row,
	Button,
	Toast,
	Dialog,
} from "vant";
import wx from "weixin-jsapi";
import { Get, Post } from "@/utils/Api";

export default {
	components: {
		[Cell.name]: Cell,
		[CellGroup.name]: CellGroup,
		[NavBar.name]: NavBar,
		[VanImage.name]: VanImage,
		[Popup.name]: Popup,
		[Grid.name]: Grid,
		[GridItem.name]: GridItem,
		[Col.name]: Col,
		[Row.name]: Row,
		[Button.name]: Button,
		[Toast.name]: Toast,
		[Dialog.name]: Dialog,
	},
	data: function() {
		return {
			jifen: 50,
			userInfo: {
				nickName: null,
				headImgUrl: null,
				schoolName: null,
				vipEndDate: "",
				yj: 0,
			},
			selectedCard: false,
			showCharge_Date: false,
			cards_date: [
				{
					name: "月卡",
					display: "31",
					price: 30,
					id: 11,
					cls: "",
				},
				{
					name: "季卡",
					display: "95",
					price: 90,
					id: 12,
					cls: "",
				},
				{
					name: "半年卡",
					display: "195",
					price: 180,
					id: 13,
					cls: "",
				},
				{
					name: "月卡",
					display: "400",
					price: 360,
					id: 14,
					cls: "",
				},
			],
			leftTimes: 55,
			showCharge_Time: false,
			cards_time: [
				{
					name: "10",
					display: "9.9",
					price: 9.9,
					id: 21,
					cls: "",
				},
				{
					name: "50",
					display: "48",
					price: 48,
					id: 22,
					cls: "",
				},
				{
					name: "100",
					display: "95",
					price: 95,
					id: 23,
					cls: "",
				},
				{
					name: "200",
					display: "180",
					price: 180,
					id: 24,
					cls: "",
				},
			],
		};
	},
	mounted: function() {
		this.getUserInfo();
		this.getWeChatParams();
	},
	created: function() {},
	methods: {
		getUserInfo() {
			//加载用户信息
			var openId = localStorage.getItem("openId");
			Get(
				"getCurrentUserInfo",
				{
					openId: openId,
				},
				(res) => {
					var data = res.data.data;
					if (data.length > 0) {
						this.userInfo = data[0];
						// this.headImgUrl = D.headImgUrl;
						// this.nickName = D.nickName;
						// this.schoolName = D.schoolName;
						// this.vipEndDate = D.vipEndDate;
						// this.yj = D.hasDeposit;
					}
					console.log("用户信息", data);
				},
				(res) => {
					console.log("ERROR", res);
				}
			);
		},
		onClickLeft: function() {
			this.$router.push({ name: "home" });
		},
		onClick_DateCharge: function() {
			this.selectedCard = false;
			this.showCharge_Date = true;
			for (var i = 0; i < this.cards_date.length; i++) {
				var card = this.cards_date[i];
				card.cls = "";
			}
		},
		onGridItemClick_DateCharge: function(id) {
			for (var i = 0; i < this.cards_date.length; i++) {
				var card = this.cards_date[i];
				card.cls = card.id == id ? "grid-item-selected" : "";
			}
			this.selectedCard = true;
			console.log(id);
		},
		onClick_TimeCharge: function() {
			this.selectedCard = false;
			this.showCharge_Time = true;
			for (var i = 0; i < this.cards_time.length; i++) {
				var card = this.cards_time[i];
				card.cls = "";
			}
		},
		onGridItemClick_TimeCharge: function(id) {
			for (var i = 0; i < this.cards_time.length; i++) {
				var card = this.cards_time[i];
				card.cls = card.id == id ? "grid-item-selected" : "";
			}
			this.selectedCard = true;
			console.log(id);
		},
		getWeChatParams() {
			console.log("getWeChatParams");
			Get(
				"getWeChatParams",
				{},
				(r) => {
					console.log("getWeChatParams", r);
					var data = r.data.data;
					wx.config({
						debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
						appId: data.appId, // 必填，公众号的唯一标识
						timestamp: data.timestamp, // 必填，生成签名的时间戳
						nonceStr: data.nonceStr, // 必填，生成签名的随机串
						signature: data.signature, // 必填，签名
						jsApiList: ["chooseWXPay"], // 必填，需要使用的JS接口列表
					});
					wx.ready(function() {
						console.log("Check JSAPI");
						wx.checkJsApi({
							jsApiList: ["chooseWXPay"],
							success: function(res) {
								console.log("success");
								console.log(res);
							},
							fail: function(res) {
								console.log("fail");
								console.log(res);
							},
						});
					});
				},
				(r) => {
					console.log(r);
				}
			);
		},
		onClick_wxPay_date: function() {
			var openId = localStorage.getItem("openId");
			Post(
				"pay/date",
				{
					openId: openId,
				},
				(res) => {
					var r = res.data;
					if (r.success) {
						wx.chooseWXPay({
							appId: r.data.appId,
							timestamp: r.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
							nonceStr: r.data.nonceStr, // 支付签名随机串，不长于 32 位
							package: r.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
							signType: r.data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
							paySign: r.data.sign, // 支付签名
							success: function(res) {
								// 支付成功后的回调函数
								//alert(res);
								Toast.success(res);
								this.getUserInfo();
							},
							// 支付取消回调函数
							cencel: function(res) {
								Toast.fail("用户取消支付~", res);
							},
							// 支付失败回调函数
							fail: function(res) {
								Toast.fail("支付失败~", res);
							},
						});
					}
					console.log("预支付请求", r);
				},
				(res) => {
					console.log("ERROR", res);
				}
			);
		},

		onClick_wxPay_times: function() {
			var openId = localStorage.getItem("openId");
			Post(
				"pay/times",
				{
					openId: openId,
				},
				(res) => {
					var r = res.data;
					if (r.success) {
						wx.chooseWXPay({
							appId: r.data.appId,
							timestamp: r.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
							nonceStr: r.data.nonceStr, // 支付签名随机串，不长于 32 位
							package: r.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
							signType: r.data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
							paySign: r.data.sign, // 支付签名
							success: function(res) {
								// 支付成功后的回调函数
								//alert(res);
								Toast.success(res);
								this.getUserInfo();
							},
							// 支付取消回调函数
							cencel: function(res) {
								Toast.fail("用户取消支付~", res);
							},
							// 支付失败回调函数
							fail: function(res) {
								Toast.fail("支付失败~", res);
							},
						});
					}
					console.log("预支付请求", r);
				},
				(res) => {
					console.log("ERROR", res);
				}
			);
		},

		onClick_wxPay_yj: function() {
			var openId = localStorage.getItem("openId");
			Post(
				"pay/yj",
				{
					openId: openId,
				},
				(res) => {
					var r = res.data;
					if (r.success) {
						wx.chooseWXPay({
							appId: r.data.appId,
							timestamp: r.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
							nonceStr: r.data.nonceStr, // 支付签名随机串，不长于 32 位
							package: r.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
							signType: r.data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
							paySign: r.data.sign, // 支付签名
							success: function(res) {
								// 支付成功后的回调函数
								//alert(res);
								Toast.success("充值成功", res);
								this.getUserInfo();
							},
							// 支付取消回调函数
							cencel: function(res) {
								Toast.fail("用户取消支付~", res);
							},
							// 支付失败回调函数
							fail: function(res) {
								Toast.fail("支付失败~", res);
							},
						});
					}
					console.log("预支付请求", r);
				},
				(res) => {
					console.log("ERROR", res);
				}
			);
		},

		onClick_wxPay_refundYJ: function() {
			Dialog.confirm({
				title: "信息提示",
				message: "确认申请退还押金?",
			}).then(() => {
				var openId = localStorage.getItem("openId");
				Post(
					"pay/refund/yj",
					{
						openId: openId,
					},
					(res) => {
						var r = res.data;
						if (r.success) {
							// wx.chooseWXPay({
							// 	appId: r.data.appId,
							// 	timestamp: r.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
							// 	nonceStr: r.data.nonceStr, // 支付签名随机串，不长于 32 位
							// 	package: r.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
							// 	signType: r.data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
							// 	paySign: r.data.sign, // 支付签名
							// 	success: function(res) {
							// 		// 支付成功后的回调函数
							// 		//alert(res);
							Toast.success(r.msg);
							this.getUserInfo();
							// 	},
							// 	// 支付取消回调函数
							// 	cencel: function(res) {
							// 		Toast.fail("用户取消支付~", res);
							// 	},
							// 	// 支付失败回调函数
							// 	fail: function(res) {
							// 		Toast.fail("支付失败~", res);
							// 	},
							// });
						} else {
							Toast.fail("申请退款失败：" + r.msg);
						}
					},
					(res) => {
						console.log("ERROR", res.msg);
					}
				);
			});
		},
	},
};
</script>

<style lang="less">
.avanta {
	float: left;
	border-radius: 10%;
}
.name {
	padding-left: 10px;
	height: 50px;
	line-height: 50px;
	width: 60%;
	font-size: 20px;
	font-weight: bolder;
	display: block;
	float: left;
}

.school {
	font-size: 14px;
	font-weight: normal;
}

.grid-margin {
	margin-top: 10px;
}

.van-grid-item__content {
	border-radius: 10px;
	border: 1px solid #ff0000;
}

.van-grid-item__content--surround:after,
.van-grid-item__content:after {
	border: none;
}

.grid-item-selected .van-grid-item__content {
	color: #ffffff;
	background-color: #ff0000;
	border-radius: 10px;
}

.btn-wxpay {
	margin-top: 10px;
}
</style>
